<script lang="ts">
	export let title: string;
	export let onClick: () => void | null;
	export let component: 'link' | 'btn';
	export let linkTo: string | null;
	export let isExternalLink = false;
</script>

{#if component === 'btn'}
	<button class="button" on:click={onClick}>{title}</button>
{:else}
	<a class="button" href={linkTo} target={isExternalLink ? '_blank' : '_self'} rel="noreferrer"
		>{title}</a
	>
{/if}

<style lang="scss">
	@import 'customButton';
</style>
